import type { FaireProductEntity } from "../../entity_types/product";

export const p_9223nde5um: FaireProductEntity = {
  token: "p_9223nde5um",
  type: "product",
  name: "Sphere Apatite approx. 40-50mm",
  brandToken: "b_pfe5z89pnk",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a8f88b70e0f59b6ee73291f3a3d1624f88c7453e85a7d956316a83165705fac3.jpeg",
  galleryImageUrls: [],
  priceDollars: 18,
  description: "Sphere made of natural stone in India. Approx. 40-50mm",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:58.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
